import { Card } from "@common/components/ui/card"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { AircraftForm } from "@/routes/_layout/aircraft/-components/form/aircraft-form"

export const Route = createFileRoute("/_layout/aircraft_/new")({
  staticData: {
    breadcrumb: [
      { label: "Aircraft", href: "/aircraft" },
      { label: "New aircraft" },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "aircraft:create", "/"),
  component: NewAircraftPage,
})

function NewAircraftPage(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()

  return (
    <div className="h-full overflow-y-auto">
      <PageContent>
        <PageTitle title="New aircraft" />
        <Card className="p-4 shadow-none">
          <AircraftForm
            onSaved={(created) => {
              showToast(
                "Created",
                `${created.registration_no} added.`,
                "success",
              )
              navigate({
                to: "/aircraft/$aircraftId",
                params: { aircraftId: created.id },
              })
            }}
            onCancel={() => navigate({ to: "/aircraft" })}
          />
        </Card>
      </PageContent>
    </div>
  )
}
